@import 'styles/mixins';
@import 'styles/variables';

.settingsHeader {
  @include header-md;
  align-items: center;
  color: $almanac-black;
  display: flex;
  height: 56px;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid $gray-10;
}

.newHeader {
  padding-left: 0px;

  [data-autopilot-system-redesign='on'] & {
    margin-right: -40px;
    margin-left: -40px;
    padding-left: 40px;

    h3 {
      font-size: 16px !important;
    }
  }
}

.leftSidebarHeader {
  padding-left: 12px;
}

.header {
  @include xl-semibold;
  color: $gray-90;
  margin-bottom: 32px;
}

.headerButtons {
  margin-left: auto;
}

.subHeader {
  h1 {
    @include xl-semibold;
    color: var(--neutral-90);
    margin-bottom: 24px;
  }

  p {
    @include md-regular;
    color: $grey-40;
    margin-bottom: 28px;
  }
}

.closeButton {
  display: flex;
  align-items: center;

  & svg {
    fill: $almanac-black;
  }
}

.body {
  display: flex;
  height: 80vh;
  margin-top: 20px;

  [data-ff-settings-modal-update='on'] & {
    margin-top: 0;
  }

  [data-ff-settings-modal-update='on'] & {
    height: 100%;
    max-height: 80vh;
  }
}

.rightSideBar,
.leftSideBar {
  @include thinScrollbar;

  flex-grow: 1;
}

.leftSideBar {
  flex: 0 1 auto;
  min-width: 200px;
  padding-left: 8px;

  &.settingsModalUpdate {
    background: var(--background, #f3f5f6);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

    [data-autopilot-system-redesign='on'] & {
      border-top-left-radius: 16px;
      border-bottom-left-radius: 16px;
    }
  }
}

.rightSideBar {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 0 20px 66px 20px;
  min-width: 860px;

  &.settingsModalUpdate {
    padding: 10px 40px 66px 40px;

    [data-autopilot-system-redesign='on'] & {
      padding: 0 40px 66px 40px;
    }
  }
}

.rightContent {
  min-width: 640px;
  max-width: 1146px;
}

.titleContainer {
  align-items: center;
  display: flex;
}

.dFlex {
  display: flex;
}

.sectionWrapper {
  padding: 32px 0 0 0;
}

.settingsSection {
  padding-bottom: 20px;
  padding-top: 10px;

  .settingsOption {
    .toggleRow {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    .helpText {
      @include md-regular;
      color: $grey-40;
      margin-top: 8px;
      width: 100%;
      display: flex;

      .text {
        flex-grow: 1;
        max-width: 80%;
      }

      .right {
        display: flex;
        flex-grow: 1;
        justify-content: flex-end;
      }
    }

    .optionHeader {
      @include md-semibold;

      color: $gray-90;
      display: flex;
      align-items: center;
    }

    .saveButton {
      width: 118px;
      height: 32px;

      &:disabled {
        pointer-events: none;
        cursor: default;
        background-color: $grey-10;
        box-shadow: none;
        color: $grey-50;
        border: none;
      }
    }

    .inputRow {
      padding: 16px 0 16px 0;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .settingsOption + .settingsOption {
    margin-top: 32px;
  }
}

.divider {
  background: var(--neutral-10);
  min-height: 1px;
  height: 1px;
  width: 100%;
}

.releaseInfo {
  padding: 8px 16px;
  @include sm-regular;
  color: var(--neutral-40);
  max-width: 200px;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@include for-tablet-portrait-max {
  .rightSideBar {
    min-width: initial;
  }
}

.headerButtons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.mobileSettings {
  margin-top: 14px;
}
